import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {RestService} from "../../core/services/rest.service";
import {RpsFilter} from "../filters/rps.filter";
import {RpsTO} from "../../../classes/to/rps.to";

@Injectable()
export class PublicRpsService {

  constructor(private restService: RestService) {
  }

  buscarRps(rpsFilter: RpsFilter): Observable<RpsTO> {
    return this.restService.post("/public/rps/buscarRps", {data: rpsFilter, responseType: RpsTO});
  }

}
